import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Table } from '../../components/Table/Table';
import { itemsInventoryNavigation } from './constants/itemsInventory';
import DealCombosScreen from './screens/DealCombosScreen/DealCombosScreen';
import MealCombosScreen from './screens/MealCombosScreen/MealCombosScreen';
import ProductsScreen from './screens/ProductsScreen/ProductsScreen';
import ScreenHeader from 'src/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import { SCREENS } from 'src/constants/screens';
import { appStore } from '~/mobx/appStore';

const ItemsInventoryScreen: React.FC = (): JSX.Element => {
  return (
    <Table>
      <>
        <ScreenHeader title="items_and_inventory" options={itemsInventoryNavigation()} />
        <Table>
          <Switch>
            <Route path={SCREENS.PRODUCTS()} component={ProductsScreen} />
            <CustomRoute path={SCREENS.DEAL_COMBOS()} component={DealCombosScreen} access={appStore.isAddonsAvailable.deals} />
            <CustomRoute path={SCREENS.MEAL_COMBOS()} component={MealCombosScreen} access={appStore.isAddonsAvailable.meals} />
          </Switch>
        </Table>
      </>
    </Table>
  );
};

export default ItemsInventoryScreen;
